import TranslationStore from "./TranslationStore";
import MyTibStore from "./MyTibStore";
import MyTimStore from "./MyTimStore";
import NotificationsStore from "./NotificationsStore";
import SictmStore from "./SictmStore";
import NextTravelStore from "./NextTravelStore";
import React from "react";

export const storesContext = React.createContext({
  myTibStore: new MyTibStore(),
  nextTravelStore: new NextTravelStore(),
  translationStore: new TranslationStore(),
  myTimStore: new MyTimStore(),
  notificationStore: new NotificationsStore(),
  sictmStore: new SictmStore(),
});
